export const ArgumentativeEssayPrep = {
  title: 'Argumentative Essay Prep',
  icon: '/static/templates_icons/ArgumentativeEssayPrep.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#argumentative-essay-prep">https://parlayideas.com/templates/#argumentative-essay-prep</a>]
    </p>
    <h3>Introduction</h3>
    <p>
      In this discussion we’re going to share our thesis and supporting evidence for our upcoming
      argumentative essays on <span class="pink-selectable">[essay topic]</span> The goal of this exercise is to gain new perspectives
      on the topic and to refine our ideas before writing and submitting our final paper.
    </p>
    <h3>Part 1 - Thesis Statement</h3>
    <p>
      First, share your thesis statement. The statement should be one sentence long, succinctly
      explaining the main idea/claim of your essay. Don't worry about your thesis being "perfect" for
      this RoundTable. The goal of this exercise is to have others review it and provide feedback so
      you can improve it.
    </p>
    <h3>Part 2 - Supporting Statements & Evidence</h3>
    <p>
      Next, share each of the three (or more) main points that you are using to support your thesis in
      your essay. Back up each one of your points with at least one piece of appropriate evidence,
      and don’t forget to cite your sources. Use the following format:
    </p>
    <p><strong>
      1. Supporting Point: <br>
      &nbsp;&nbsp; Evidence: <br>
      &nbsp;&nbsp; Source:
    </strong></p>
    <p><strong>
      2. Supporting Point: <br>
      &nbsp;&nbsp; Evidence: <br>
      &nbsp;&nbsp; Source:
    </strong></p>
    <p><strong>
      3. Supporting Point: <br>
      &nbsp;&nbsp; Evidence: <br>
      &nbsp;&nbsp; Source:
    </strong></p>
    <h3 class="pink-selectable">Part 3 - Refusing Opposing Viewpoints (Bonus)</h3>
    <p class="pink-selectable">
      Finally, share 1-2 common opposing viewpoints to your thesis along with your rebuttals and
      evidence to support those rebuttals. You can use this in place of or in addition to your supporting
      statements above:
    </p>
    <p><strong class="pink-selectable">
      1. Opposing Viewpoint: <br>
      &nbsp;&nbsp; Refutation: <br>
      &nbsp;&nbsp; Evidence: <br>
      &nbsp;&nbsp; Source:
    </strong></p>
    <p><strong>
    <h3>Part 4 - Peer Feedback</h3>
    <p>
      After submitting your post, read through and provide feedback on at least <span class="pink-selectable">two</span> of your peers'
      submissions. Answer the guided feedback questions provided in your comment. Try your best to
      comment on submissions that don’t yet have any feedback. It is important that everyone has the
      opportunity to improve their ideas!:
    </p>
  `,
};



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/ArgumentativeEssayPrep.js